import React, { Fragment, useState } from "react";
import { Button, dialog } from "nq-component";
import View from "./components/View";
import Checkbox from "nq-component/dist/Checkbox";
import Accordion from "nq-component/dist/Accordion";
import OutputFactory from "../OutputFactory";
import AccordionProvider from "nq-component/dist/Accordion/AccordionProvider";
import { Popover } from "antd";
import { insertAfterKey } from "../common/Converter";

function Body({
  currectRoles,
  empPointer,
  indexCount,
  handleDelete,
  handleEdit,
  handlePrint,
  singleObjet,
  singleObjetDis,
  HRAction,
  viewObject,
  increment,
  separate,
  generate,
  assignBank,
  appearance,
  training,
  addTrain,
  printTrain,
  payrollViewing,
  payslipViewing,
  payrollListing,
  payrollVoucher,
  serviceRecord,
  leavesRecord,
  salaryAdjustment,
  disciplinaryRecord,
  stepIncrement,
  removePayroll,
  payslipPrinting,
  handleViewAP,
  handleViewBasic,
  disbursementPrinting,
  deleteDisbursement,
  onEditPayrollType,
  refetch,
  collection,
  objects,
  fields,
  excludeFields,
  selected,
  selectable,
  onSelect,
  onClick,
  onLongPress,
  specialColumn,
  actionsList,
  onCollapse,
  toggleable,
  actions,
  onClickItem,
  selectedItem,
  fieldImage,
  fieldPointer = [],
}) {
  if (Array.isArray(fieldPointer) && fieldPointer.length > 0) {
    fields = insertAfterKey(
      fields,
      "employee",
      "fieldPointer",
      fieldPointer[0],
    );
  }
  const handleViewOnClick = (object) => {
    if (
      collection.collection === "schedule_template" ||
      collection.collection === "ipcr" ||
      collection.collection === "opcr" ||
      collection.collection === "dpcr" ||
      collection.collection === "spcr" ||
      collection.collection === "users" ||
      collection.collection === "roles" ||
      collection.collection === "library" ||
      collection.collection === "position_titles" ||
      collection.collection === "daily_time_record" ||
      collection.collection === "salary_grade" ||
      collection.collection === "tax-table" ||
      collection.collection === "group_schedule" ||
      collection.collection === "committee" ||
      collection.collection === "manual_dtr" ||
      collection.collection === "commendation_list" ||
      collection.collection === "notice_templates" ||
      collection.collection === "consultation" ||
      collection.collection === "dental_consultation" ||
      collection.collection === "suspension" ||
      collection.collection === "job_postings" ||
      collection.collection === "medical_record"
    ) {
      viewObject(object);
    } else {
      dialog.fire({
        html: <View object={object} collection={collection} />,
        footer: false,
      });
    }
  };

  const [selectedObj, setSelectedObj] = useState(null);

  const handleAction = (type, data) => {
    switch (type) {
      case "edit":
        handleEdit(data.id);
        break;
      case "delete":
        handleDelete(data);
        break;
      case "object":
        singleObjet(data);
        break;
      case "objectDis":
        singleObjetDis(data);
        break;
      case "hr":
        HRAction(data);
        break;
      case "increment":
        increment(data);
        break;
      case "separated":
        separate(data);
        break;
      case "generate":
        generate(data);
        break;
      case "viewEmployee":
        viewObject(data);
        break;
      case "assign":
        assignBank(data);
        break;
      case "viewPayroll":
        payrollViewing(data);
        break;
      case "payslip":
        payslipViewing(data);
        break;
      case "payroll":
        payrollListing(data);
        break;
      case "voucher":
        payrollVoucher(data);
        break;
      case "printPayslip":
        payslipPrinting(data);
        break;
      case "printDisbursement":
        disbursementPrinting(data);
        break;
      case "removeDisbursement":
        deleteDisbursement(data);
        break;
      case "ofAppearance":
        appearance(data);
        break;
      case "ofTraining":
        training(data);
        break;
      case "viewService":
        serviceRecord(data);
        break;
      case "viewLeaves":
        leavesRecord(data);
        break;
      case "viewSalary":
        salaryAdjustment(data);
        break;
      case "viewDisciplinary":
        disciplinaryRecord(data);
        break;
      case "viewStepIncrement":
        stepIncrement(data);
        break;
      case "addTraining":
        addTrain(data);
        break;
      case "printTraining":
        printTrain(data);
        break;
      case "remove":
        removePayroll(data);
        break;
      case "performance":
        handlePrint(data);
        break;
      case "viewAP":
        handleViewAP(data);
        break;
      case "viewBasic":
        handleViewBasic(data);
        break;
      case "editPayrollType":
        onEditPayrollType(data);
        break;
      default:
        break;
    }
  };

  return objects.map((object, index) => {
    const id = object?.id || object?._id;
    // const checked = selected.includes(object);
    const checked = selected.some((item) => item.id === object.id);

    const actionsMap = {
      daily_time_record: [
        {
          label: "View",
          icon: "bi bi-search",
          action: () => handleViewOnClick(object),
        },
        ...(currectRoles
          ? [
              {
                label: "Update",
                icon: "bi bi-pen",
                action: () => handleAction("hr", object),
              },
            ]
          : []),
        // {
        //   label: "Request Overtime",
        //   icon: "bi bi-pencil-square",
        //   action: () => handleAction("delete", object),
        // },
        // {
        //   label: "TO",
        //   icon: "bi bi-pencil-square",
        //   action: () => handleAction("hr", object),
        // },
        // {
        //   label: "OB",
        //   icon: "bi bi-pencil-square",
        //   action: () => handleAction("ofTraining", object),
        // },
        // {
        //   label: "Time OFF",
        //   icon: "bi bi-alarm",
        //   action: () => handleAction("generate", object),
        // },
        {
          label: "Slide",
          icon: "bi bi-sliders",
          action: () => handleAction("payslip", object),
        },
        ...(object.accesspasstimestatus === "Pending"
          ? [
              {
                label: "Approve",
                icon: "bi bi-check-lg",
                action: () => handleAction("increment", object),
              },
              {
                label: "Reject",
                icon: "bi bi-x-lg",
                action: () => handleAction("separated", object),
              },
            ]
          : []),
      ],
      "Employees List": [
        {
          label: "View",
          icon: "bi bi-search",
          action: () => handleAction("viewEmployee", object),
        },
        ...(!currectRoles
          ? [
              {
                label: "Edit",
                icon: "bi bi-pen",
                action: () => handleAction("edit", object),
              },
              {
                label: "HR Action",
                icon: "bi bi-person-lines-fill",
                action: () => handleAction("hr", object),
              },
              {
                label: "Step Increment",
                icon: "bi bi-graph-up-arrow",
                action: () => handleAction("increment", object),
              },
              {
                label: "Separated Employee",
                icon: "bi bi-person-fill-x",
                action: () => handleAction("separated", object),
              },
              // {
              //   label: "Generate Leave Card",
              //   icon: "bi bi-person-fill-x",
              //   action: () => handleAction("generate", object),
              // },
              {
                label: "Delete",
                icon: "bi bi-trash",
                action: () => handleAction("viewPayroll", object),
              },
              {
                label: "UnSuspension",
                icon: "bi bi-arrow-left-right",
                action: () => handleAction("ofAppearance", object),
              },
              {
                label: "Suspension",
                icon: "bi bi-arrow-left-right",
                action: () => handleAction("ofTraining", object),
              },
            ]
          : []),
      ],
      "Print Payroll List": [
        {
          label: "View",
          icon: "bi bi-view-list",
          action: () => handleAction("viewPayroll", object),
        },
        {
          label: "Generate Payslip",
          icon: "bi bi-card-checklist",
          action: () => handleAction("payslip", object),
        },
        {
          label: "Print Payroll Listing",
          icon: "bi bi-list-ul",
          action: () => handleAction("payroll", object),
        },
        {
          label: "Generate Disbursement Voucher",
          icon: "bi bi-person-lines-fill",
          action: () => handleAction("voucher", object),
        },
        ...(object.stats === "Pending"
          ? [
              {
                label: "Print",
                icon: "bi bi-printer",
                action: () => handleAction("printPayslip", object),
              },
              {
                label: "Delete",
                icon: "bi bi-trash",
                action: () => handleAction("remove", object),
              },
            ]
          : []),
      ],
      "OB Approval List": [
        {
          label: "View",
          icon: "bi bi-eye",
          action: () => handleAction("viewPayroll", object),
        },
        ...(object.status !== "Forwarded to CEBS" &&
        object.status !== "Disapproved" && object.status !== "Approved"
          ? [
              {
                label: "Approve",
                icon: "bi bi-check-circle",
                action: () => handleAction("increment", object),
              },
              {
                label: "Disapprove",
                icon: "bi bi-x-circle",
                action: () => handleAction("separated", object),
              },
            ]
          : []),
      ],
      "OB Management List": [
        {
          label: "View",
          icon: "bi bi-eye",
          action: () => handleAction("viewPayroll", object),
        },
        ...(object.status !== "Approved" && object.status !== "Disapproved"
          ? [
              {
                label: "Approve",
                icon: "bi bi-check-circle",
                action: () => handleAction("increment", object),
              },
              {
                label: "Disapprove",
                icon: "bi bi-x-circle",
                action: () => handleAction("separated", object),
              },
            ]
          : []),
      ],

      "OB Request": [
        {
          label: "View",
          icon: "bi bi-search",
          action: () => handleAction("viewEmployee", object),
        },
      ],

      "Print Payroll Disbursement": [
        {
          label: "View",
          icon: "bi bi-search",
          action: () => handleAction("viewPayroll", object),
        },
        {
          label: "Generate Payslip",
          icon: "bi bi-printer",
          action: () => handleAction("payslip", object),
        },
        {
          label: "Print Payroll Listing",
          icon: "bi bi-list-ul",
          action: () => handleAction("payroll", object),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          action: () => handleAction("remove", object),
        },
      ],

      "Employee Earnings": [
        {
          label: "AP Earnings",
          icon: "bi bi-arrow-right",
          action: () => handleAction("viewAP", object),
        },
        {
          label: "Basic Earnings",
          icon: "bi bi-arrow-right",
          action: () => handleAction("viewBasic", object),
        },
      ],

      "Print Payslip": [
        {
          label: "Print",
          icon: "bi bi-printer",
          action: () => handleAction("printPayslip", object),
        },
        // {
        //   label: "Delete",
        //   icon: "bi bi-trash",
        //   action: () => handleAction("remove", object),
        // },
      ],

      "Print Disbursement": [
        {
          label: "Print",
          icon: "bi bi-printer",
          action: () => handleAction("printDisbursement", object),
        },
        {
          label: "Delete",
          icon: "bi bi-trash",
          action: () => handleAction("removeDisbursement", object),
        },
      ],

      MDS: [
        {
          icon: "bi bi-search",
          label: "View",
          action: () => handleViewOnClick(object),
        },
        {
          icon: "bi bi-pen",
          label: "Edit",
          action: () => handleAction("edit", object),
        },
        ...(collection.collection === "commendation_list"
          ? []
          : [
              {
                icon: `bi bi-trash`,
                label: `Delete`,
                action: () => handleAction("delete", object),
              },
            ]),
        {
          icon: "bi bi-printer",
          label: "Print",
          action: () => handleAction("generate", object),
        },
      ],
      common: [
        {
          icon: "bi bi-search",
          label: "View",
          action: () => handleViewOnClick(object),
        },
        {
          icon: "bi bi-copybi bi-files-alt",
          label: "Edit",
          action: () => handleAction("edit", object),
        },
        ...(collection.collection === "roles"
          ? [
              {
                icon: `bi bi-clipboard`,
                label: "Clone",
                action: () => handleAction("generate", object),
              },
            ]
          : []),

        // remove on schedule
        ...(object?.id !== "fba6b548-72ae-44ab-98bd-ebb4ec613d3a" &&
        object.id !== "0c8ff78c-352b-42ae-8bc2-aecf8f740c66" &&
        object.id !== "39224716-8b72-436e-8162-749542dfcdf4"
          ? [
              {
                icon: "bi bi-trash",
                label: "Delete",
                action: () => handleAction("delete", object),
              },
            ]
          : []),
      ],
      performance: [
        {
          icon: "bi bi-search",
          label: "View",
          action: () => handleViewOnClick(object),
        },
        {
          icon: "bi bi-pen",
          label: "Edit",
          action: () => handleAction("edit", object),
        },
        {
          icon: `${
            collection.collection === "roles"
              ? "bi bi-copybi bi-files-alt"
              : "bi bi-trash"
          }`,
          label: `${collection.collection === "roles" ? "Clone" : "Delete"}`,
          action: () => handleAction("delete", object),
        },
        {
          label: "Generate Performance",
          icon: "bi bi-printer",
          action: () => handleAction("performance", object),
        },
        // {
        //   label: "Generate Excel",
        //   icon: "bi bi-printer",
        //   action: () => handleAction("assign", object),
        // },
      ],
      user: [
        {
          icon: "bi bi-search",
          label: "View",
          action: () => handleViewOnClick(object),
        },
        {
          icon: "bi bi-pen",
          label: "Edit",
          action: () => handleAction("edit", object),
        },
        {
          icon: "bi bi-fingerprint",
          label: "Assign Biometric Device",
          action: () => handleAction("hr", object),
        },

        // {
        //   icon: "bi bi-fingerprint",
        //   label: "Assign Biometric Finger",
        //   action: () =>
        //     handleAction("separated", object),
        // },
        {
          icon: "bi bi-arrow-clockwise",
          label: "Reset Password",
          action: () => handleAction("increment", object),
        },
        {
          icon: "bi bi-fingerprint",
          label: "Remove Fingerprint",
          action: () => handleAction("ofTraining", object),
        },
      ],
      view: [
        {
          icon: "bi bi-search",
          label: "View",
          action: () => handleViewOnClick(object),
        },
      ],
      // job: [
      //   {
      //     icon: "bi bi-search",
      //     label: "View",
      //     action: () => HRAction(object),
      //   },
      //   {
      //     icon: "bi bi-pen",
      //     label: "Edit",
      //     action: () => handleAction("edit", object),
      //   },
      //   {
      //     icon: "bi bi-trash",
      //     label: "Delete",
      //     action: () => handleAction("delete", object),
      //   },
      //   // object.closed === "false"
      //   //   ? {
      //   //       icon: "bi bi-x-lg",
      //   //       label: "Close",
      //   //       action: () => handleAction("delete", object),
      //   //     }
      //   //   : {
      //   //       icon: "bi bi-check-lg",
      //   //       label: "Re-Open",
      //   //       action: () => handleAction("object", object),
      //   //     },
      // ].filter(Boolean),
      "Assign Bank List": [
        {
          icon: "bi bi-search",
          label: "Assign Bank Details",
          action: () => handleAction("assign", object),
        },
      ],
      "View Certificate": [
        {
          icon: "bi bi-search",
          label: "Certificate of Appearance",
          action: () => handleAction("ofAppearance", object),
        },
        {
          icon: "bi bi-search",
          label: "Certificate of Training",
          action: () => handleAction("ofTraining", object),
        },
      ],
      "Attendees List": [
        {
          icon: "bi bi-search",
          label: "Add To Certificate of Training",
          action: () => handleAction("addTraining", object),
        },
        {
          icon: "bi bi-search",
          label: "Print Certificate",
          action: () => handleAction("printTraining", object),
        },
      ],
      "Service Report": [
        {
          icon: "bi bi-eye",
          label: "View",
          action: () => handleAction("viewService", object),
        },
      ],
      "Leaves Report": [
        {
          icon: "bi bi-eye",
          label: "View",
          action: () => handleAction("viewLeaves", object),
        },
      ],
      "Salary Adjustment": [
        {
          icon: "bi bi-eye",
          label: "View",
          action: () => handleAction("viewSalary", object),
        },
      ],
      "Disciplinary Report": [
        {
          icon: "bi bi-eye",
          label: "View",
          action: () => handleAction("viewDisciplinary", object),
        },
      ],
      "Payroll Type": [
        {
          icon: "bi bi-pencil-square",
          label: "Edit",
          action: () => handleAction("editPayrollType", object),
        },
      ],
      "Step Increment": [
        {
          icon: "bi bi-eye",
          label: "View",
          action: () => handleAction("viewStepIncrement", object),
        },
      ],
      "Office Assignment": [
        {
          icon: "bi bi-eye",
          label: "View Organizational Structure",
          action: () => handleAction("hr", object),
        },
        {
          icon: "bi bi-eye",
          label: "View Assigned Biometric Device",
          action: () => handleAction("increment", object),
        },
      ],
      "Employee Records": [
        {
          icon: "bi bi-eye",
          label: "View",
          action: () => handleAction("hr", object),
        },
        {
          icon: "bi bi-pencil-square",
          label: "Edit",
          action: () => handleAction("editPayrollType", object),
        },
      ],
      applicant:
        // object.status === "Hired" || object.status === "Rejected"
        //   ?
        [
          {
            icon: "bi bi-search",
            label: "View Applicant",
            action: () => HRAction(object),
          },
        ],
      // : [
      //     {
      //       icon: "bi bi-search",
      //       label: "View Applicant",
      //       action: () => HRAction(object),
      //     },
      //     {
      //       icon: "bi bi-pen",
      //       label: "Update Status",
      //       action: () => handleAction("ofAppearance", object),
      //     },
      //     {
      //       icon: "bi bi-pen",
      //       label: "Schedule Interview/Exam",
      //       action: () => handleAction("ofTraining", object),
      //     },
      //   ],
      biometric: [
        {
          icon: "bi bi-pen",
          label: "Edit",
          action: () => handleAction("object", object),
        },
        {
          icon: "bi bi-arrow-clockwise",
          label: "Reboot",
          action: () => handleAction("hr", object),
        },
        {
          icon: "bi bi-arrow-clockwise",
          label: "Clear Logs",
          action: () => handleAction("ofTraining", object),
        },
        {
          icon: "bi bi-fingerprint",
          label: "Assigned User",
          action: () => handleAction("printTraining", object),
        },
        {
          icon: "bi bi-arrow-repeat",
          label: "Sync logs",
          action: () => handleAction("increment", object),
        },
        {
          icon: "bi bi-arrow-repeat",
          label: "Clear Data",
          action: () => handleAction("ofAppearance", object),
        },
      ],
    };

    const renderActions = (actions) => (
      <div className="d-grid">
        {actions.map(({ label, icon, action }, index) => (
          <Button
            key={`action-${index}`}
            type="button"
            onClick={action}
            className="w-auto h-auto border-0 bg-transparent hover pt-2 pb-2 ps-5 pe-5 d-flex text-primary"
          >
            <i className={`${icon} pe-2`} /> {label}
          </Button>
        ))}
      </div>
    );

    const bioLogsHover = (object) => {
      console.log("OBJECT: ", object);
      return (
        <div
          className="d-flex align-items-start justify-content-center"
          style={{ height: "20rem", width: "30rem" }}
        >
          <img
            src={`https://api.innque.com/v1/files/bi-hris-prod/${object.photo}`}
            alt="face Capture"
          />
          <div className="d-grid ps-2">
            {[
              { key: "device", label: "Device", value: object.device?.name },
              { key: "pin", label: "Name", value: object.pin },
              {
                key: "timestamp",
                label: "Timestamp",
                value: new Date(object.timestamp).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "numeric",
                  minute: "2-digit",
                  hour12: true,
                  timeZone: "UTC",
                }),
              },
            ].map(({ key, label, value }) => (
              <p className="fs-6" key={key}>
                <b>{label}: </b> {value}
              </p>
            ))}
          </div>
        </div>
      );
    };

    const renderActionButton = (action, object) => {
      if (!action) return null;

      const isDevice = collection.collection === "biometric_devices";

      return (
        <Fragment key={action.actionType}>
          {/* Dropdown/Popover button */}
          {action.actionType in actionsMap && (
            <Popover
              placement="bottomRight"
              content={renderActions(actionsMap[action.actionType] || [])}
              trigger="hover"
            >
              <button className="btn btn-outline-primary btn-sm fs-xs shadow-none">
                <i
                  className="bi bi-three-dots-vertical"
                  style={{ zoom: "1" }}
                />
              </button>
            </Popover>
          )}

          {/* Regular Action Button */}
          {!actionsMap[action.actionType] && !isDevice && (
            <button
              type="button"
              className="btn btn-outline-primary btn-sm fs-xs shadow-none me-2"
              onClick={() => handleAction(action.actionType, object)}
            >
              {object.isEnable === "unable" ? (
                <div style={{ width: "8rem" }}>
                  <i className="bi bi-file-text"> Close Nomination</i>
                </div>
              ) : object.isEnable === "enable" ? (
                <div style={{ width: "8rem" }}>
                  <i className="bi bi-file-text"> Open for Nomination</i>
                </div>
              ) : null}
              <i className={action.icon} /> {action.label}
            </button>
          )}

          {isDevice && action.actionType === "object" && (
            <button
              type="button"
              className="btn btn-outline-primary btn-sm fs-xs shadow-none"
              onClick={() => handleAction("object", object)}
            >
              <i className={action.icon} /> {action.label}
            </button>
          )}

          {/* Devices toggle button */}
          {isDevice && action.actionType === "assignBio" && (
            <input
              type="checkbox"
              style={{ zoom: 1.4 }}
              className="form-check-input"
              checked={
                Array.isArray(empPointer) && empPointer.includes(object.id)
              }
              onChange={() => handleAction("object", object)}
            />
          )}
        </Fragment>
      );
    };

    return (
      <AccordionProvider key={id}>
        <Popover
          placement="center"
          key={`item-${id}`}
          data-bs-target={`item-${id}-collapse`}
          content={
            collection.collection === "biometric_logs" &&
            bioLogsHover(object || [])
          }
          // trigger="hover"
          trigger="click"
        >
          <tr
            className="hover"
            style={{
              backgroundColor:
                selectedObj === object ? "#ced4da" : "transparent",
            }}
            onClick={() => setSelectedObj(object)}
            // onMouseEnter={() =>
            //   collection.collection === "biometric_logs" &&
            //   // console.log("OBJECT: ", object)
            //   bioLogsHover(object)
            // }
          >
            {selectable && (
              <th
                className="align-middle text-nowrap text-dark"
                style={{
                  padding: "1rem",
                  fontSize: "15px",
                  borderColor: "#d3d3d3",
                }}
              >
                <Checkbox
                  checked={checked}
                  id={"check_" + id}
                  onChange={() => onSelect(index)}
                />
              </th>
            )}

            {indexCount && (
              <th
                className="align-middle text-nowrap text-dark"
                style={{
                  padding: "1rem",
                  fontSize: "15px",
                  borderColor: "#d3d3d3",
                }}
              >
                {index + 1}
              </th>
            )}

            {Object.keys(fields).map((field, i) => {
              const options = fields[field];
              if (excludeFields.includes(field)) return null;
              return (
                <Accordion
                  as="td"
                  eventKey={`_${id}`}
                  key={field}
                  // className="fs-sm text-truncate"
                  className={`fs-sm${
                    options?.align === "start" ? " text-start" : ""
                  }`}
                  style={{
                    padding: "1.5rem 1rem",
                    textAlign: options?.align === "start" ? "left" : undefined,
                  }}
                >
                  <OutputFactory
                    index={index}
                    field={field}
                    // object={newObject}
                    object={object}
                    refetch={refetch}
                    collection={collection}
                    selectedItem={selectedItem}
                    fieldPointer={options}
                    {...options}
                  />
                </Accordion>
              );
            })}

            {specialColumn?.length > 0 && (
              <Accordion
                as="td"
                eventKey={`_${id}`}
                key={`special-${indexCount}`}
                className="fs-sm"
                style={{ padding: "1.5rem 1rem" }}
              >
                <div className="d-flex">
                  {specialColumn.map((action) =>
                    renderActionButton(action, object),
                  )}
                </div>
              </Accordion>
            )}

            {actionsList?.length > 0 && (
              <Accordion
                as="td"
                eventKey={`_${id}`}
                key={`action-${indexCount}`}
                className="fs-sm"
                style={{ padding: "1.5rem 1rem" }}
              >
                <div className="d-flex">
                  {actionsList.map((action) =>
                    renderActionButton(action, object),
                  )}
                </div>
              </Accordion>
            )}
          </tr>
        </Popover>
      </AccordionProvider>
    );
  });
}

export default Body;
